import { useSelector } from 'react-redux';

export default function useInitialHeaderState() {
  const {
    hasUnifiedMobileNav,
    searchType,
    searchBreedName,
    searchBreedResultsPath,
    searchBreedOverviewPagePath
  } = useSelector(({ server }) => server.initialHeaderState || {});

  return {
    hasUnifiedMobileNav,
    searchType,
    searchBreedName,
    searchBreedResultsPath,
    searchBreedOverviewPagePath
  };
}
